<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Location
        b-col(md="6")
          b-form-group(
            :label="$t('label.Location')",
            :label-for="$t('label.location')",
            description=""
          )
            validation-provider(:name="$t('label.Location')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="location",
                v-model="data.location",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}

        // Departament Leads
        b-col(md="6")
          b-form-group(
            :label="$t('label.departmentLeads')",
            :label-for="$t('label.departmentLeads')",
            description=""
          )
            v-select(
              v-model="data.departmentLeads",
              :reduce="(leads) => leads.value",
              label="title",
              :multiple="true"
              :options="leads",
              :placeholder="$t('placeholder.responsible')"
            )

        // Physical Location
        b-col(md="6")
          b-form-group(
            :label="$t('label.Physical_location')",
            :label-for="$t('label.Physical_location')",
            description=""
          )
            v-select(
              v-model="data.physical_location",
              :reduce="(physical_locations) => physical_locations.value",
              label="title",
              :options="physical_locations",
              :placeholder="$t('placeholder.physical_location')"
            )
        
        // Area
        b-col(md="6")
          b-form-group(
            :label="$t('label.Area')",
            :label-for="$t('label.Area')",
            description=""
          )
            v-select(
              v-model="data.area",
              :reduce="(areas) => areas.value",
              label="title",
              :options="areas",
              :placeholder="$t('placeholder.area')"
            )

        // Number of daily dialogues per day
        b-col(md="6")
          b-form-group(
            :label="$t('label.dailyDialoguesCount')",
            :label-for="$t('label.dailyDialoguesCount')"
          )
            validation-provider(:name="$t('label.dailyDialoguesCount')", rules="required", v-slot="{ errors }")
              b-form-spinbutton(
                id="dailyDialoguesCount",
                v-model="data.dailyDialoguesCount",
                min="0",
                max="10",
                step="1",
              )
              small.text-danger {{ errors[0] }}

        // Daily Dialogue Days of the week
        b-col(md="6")
          b-form-group
            validation-provider(:name="$t('label.daysOfWeek')", v-slot="{ errors }")
              small {{ $t('label.daysOfWeek') }}
              b-form-checkbox-group(v-model="data.dailyDialogueDays" class="d-flex flex-column flex-md-row mt-1")
                b-form-checkbox(
                  v-for="day in dayOrder"
                  :key="day"
                  :value="day"
                  class="mr-2"
                ) {{ $t('happiness.' + day) }}
              small.text-danger {{ errors[0] }}
        
        // Zone
        b-col(md="6", v-if="zoneAgencyFilter")
          b-form-group(
            :label="$t('label.Zone')",
            :label-for="$t('label.Zone')",
            description=""
          )
            v-select#zone(
              v-model="data.zone",
              :options="metadataFilterOptions.zone",
              :placeholder="$t('placeholder.zone')"
            )
        
        // Agency
        b-col(md="6", v-if="zoneAgencyFilter && !commitmentFunctionality")
          b-form-group(
            :label="$t('label.Agency')",
            :label-for="$t('label.Agency')",
            description=""
          )
            v-select#agency(
              v-model="data.agency",
              :options="metadataFilterOptions.agency",
              :placeholder="$t('placeholder.agency')"
            )

      // Button
      b-row
        b-col(
          cols="12"
          class="text-right"
        )
          b-button(
            variant="primary",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}

</template>

<script>
// eslint-disable-next-line import/extensions
import { ref, toRefs, onMounted, computed } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import useCommon from '@/views/organization/useCommon'
import vSelect from 'vue-select'
import { BFormSpinbutton, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    BFormSpinbutton,
    BFormCheckbox,
    BFormCheckboxGroup
  },

  props: ['data', 'isSubmitting'],

  setup(props, { emit }) {
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    const form = ref(null)
    const { getMetadataForDropDown, metadataFilterOptions, getPhysicalLocationsForDropDown, physical_locations, getAreasForDropDown, areas, getdepartmentLeadsForDropDown, leads } = useCommon()
    const zoneAgencyFilter = localStorage.getItem("clientData")
      ? JSON.parse(localStorage.getItem("clientData")).zone_agency_filter
      : false
    const commitmentFunctionality = JSON.parse(localStorage.getItem("clientData") || '{}').commitment_functionality
    const clientData = JSON.parse(localStorage.getItem("clientData") || '{}')
    const validateLocation = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateLocation()
      .then(() => emit('submit', toRefs(props.data)))
      .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    const dayOrder = computed(() => {
      return clientData?.default_language === 'es'
        ? [1, 2, 3, 4, 5, 6, 0]
        : [0, 1, 2, 3, 4, 5, 6]
    })

    onMounted(async () => {
      getMetadataForDropDown({category: "filter"})
      getPhysicalLocationsForDropDown()
      getAreasForDropDown()
      getdepartmentLeadsForDropDown()
    })

    return {
      required,
      form,
      validateAndSubmit,
      metadataFilterOptions,
      zoneAgencyFilter,
      commitmentFunctionality,
      physical_locations,
      areas,
      leads,
      dayOrder
    }
  },
}
</script>

<style scoped>

</style>
